module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicholas Jose\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Nicholas Jose is the author of "), _c('I', [_vm._v("The Custodians")]), _vm._v(", "), _c('I', [_vm._v("The Rose Crossing")]), _vm._v(", "), _c('I', [_vm._v("The Avenue of Eternal Peace")]), _vm._v(", and two other novels, and is the translator of several works of Chinese literature. Born in London, he lived for many years in China and now resides in Sydney, Australia.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pLqrtq/tc-custom/9781468302004.jpg?1708750475256",
      "alt": "This image is the cover for the book Rose Crossing"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rose Crossing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A fable, set in the 17th century, filled with vivid evocations of another time [and] wonderfully peculiar characters.” —"), _c('i', [_vm._v("Kirkus Reviews")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" To escape Puritan England, naturalist Edward Popple signs on to be a ship’s doctor on a journey across the Indian Ocean, and his daughter, Rosamund, stows away to accompany him. But a wreck leaves them stranded on an island off the coast of Africa."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Amid the lush vegetation, the birds and the sea turtles, father and daughter set about exploring, Edward passionately studying the island’s horticulture and Rosamund wandering about to discover its mysteries. Then a Chinese ship, with the last heir to the Ming dynasty among its passengers, arrives—and changes everything."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “The prose is ripe, laden with a sense of the forbidden, and with doom.” —"), _c('i', [_vm._v("Publishers Weekly")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “A luminous historical novel.” —"), _c('i', [_vm._v("Booklist Online")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The Overlook Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0